import React, { useState } from 'react';

function CreateOrganizationForm({ onSubmit, onCancel, loading }) {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validierung
    if (!name.trim()) {
      setError('Bitte geben Sie einen Namen ein.');
      return;
    }
    
    // Formulardaten an übergeordnete Komponente übergeben
    onSubmit({ name, description });
  };

  return (
    <div className="create-organization-form">
      <h3>Neue Organisation erstellen</h3>
      
      {error && <div className="error-message">{error}</div>}
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="orgName">Name*</label>
          <input
            id="orgName"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Name der Organisation"
            required
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="orgDescription">Beschreibung</label>
          <textarea
            id="orgDescription"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Beschreibung der Organisation (optional)"
            rows={4}
          />
        </div>
        
        <div className="form-actions">
          <button 
            type="button" 
            className="cancel-button" 
            onClick={onCancel}
            disabled={loading}
          >
            Abbrechen
          </button>
          <button 
            type="submit" 
            className="submit-button" 
            disabled={loading}
          >
            {loading ? 'Wird erstellt...' : 'Organisation erstellen'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default CreateOrganizationForm;